const RAY_EMAIL = "ray@actnowbutton.com";

export { RAY_EMAIL };
